import axios from 'axios';

export default function search(tableName, rowCount, lastEvaluatedKey, config, locationsList = false) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const actionType = locationsList ? 'SEARCH_LIST_FETCH' : 'SEARCH_FETCH';
  const url = config.postSearchService;
  return dispatch => dispatch({
    type: actionType,
    payload: axios({ method: 'post', url, headers, data: { search: { tableName, rowCount, lastEvaluatedKey } } })
  });
}


// WEBPACK FOOTER //
// ./src/actions/search.js